export const EProjectConfigurations = {
    DEFAULT_ROUTE: '/',
}
